export const IOS_LOADING_GIF_URL =
  'https://cdn.dsmcdn.com/digital-services/icons/loader-ios.gif';
export const ANDROID_LOADING_GIF_URL =
  'https://cdn.dsmcdn.com/digital-services/icons/loader-android.gif';

export const TOP_BAR_HEIGHT = 50;
export const TAB_BAR_HEIGHT = 45;
